import React, { useState } from 'react'
import {
  ImagePreviewWrapper,
  ImagePreviewWrapperSizeEnum,
} from 'UiKitComponents/ImagePreviewWrapper/ImagePreviewWrapper'
import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'
// import { AppTableMobile } from 'components/AppTable/AppTableMobile'
import { SetURLSearchParams } from 'react-router-dom'
import { SubTableRepresentVisual } from './SubTableRepresentVisual'
import { useTranslation } from 'react-i18next'
import {
  AppTableDndMobile,
  IHeaderData,
} from 'components/AppTable/AppTableDndMobile'
import { headerDataFirstValue } from 'components/AppTable/components/headerDataFirstValue'

const headerDataVisual = [
  {
    title: 'Наименование',
    colWidth: '22%',
    sort: 'name',
    order: 0,
    startPosition: 0,
  },
  { title: 'Станция', colWidth: '15%', order: 1, startPosition: 1 },
  {
    title: 'Категория',
    colWidth: '10%',
    sort: 'categoryName',
    order: 2,
    startPosition: 2,
  },
  { title: 'Дата', colWidth: '5%', order: 3, startPosition: 3 },
  { title: 'Время', colWidth: '10%', order: 4, startPosition: 4 },
  { title: 'Тип замера', colWidth: '11%', order: 5, startPosition: 5 },
  {
    title: 'Порядковый номер замера',
    colWidth: '11%',
    order: 6,
    startPosition: 6,
  },
  {
    title: 'Фактический общий вес, кг',
    colWidth: '3%',
    order: 7,
    startPosition: 7,
  },
  {
    title: 'Фактический вес без тары, кг',
    colWidth: '11%',
    sort: 'actualWeight',
    order: 8,
    startPosition: 8,
  },
  { title: 'Фото', colWidth: '5%', order: 9, startPosition: 9 },
]

interface IReportFullProps {
  reportData: IBuffetGeneralReportResult[]
  setSearchParams: SetURLSearchParams
  setCurrentSortValue: React.Dispatch<React.SetStateAction<string | null>>
}

export const ReportVisual = ({
  reportData,
  setSearchParams,
  setCurrentSortValue,
}: IReportFullProps) => {
  const [toggleAllState, setToggleAllState] = useState<number[]>([])
  const { t } = useTranslation()
  const [headerDataDnd, setHeaderData] = useState<IHeaderData[]>(
    headerDataFirstValue('report-table-visual', headerDataVisual),
  )
  const subTableRepresentFn = (
    item: IBuffetGeneralReportResult,
    currentCol?: number,
    itemIndex?: number,
    onTouchStart?: ((e: React.TouchEvent) => void) | undefined,
    onTouchMove?: ((e: React.TouchEvent) => void) | undefined,
    width?: number,
    toggleAllState?: number[],
    headerData?: IHeaderData[],
  ) => (
    <SubTableRepresentVisual
      item={item}
      currentCol={currentCol}
      itemIndex={itemIndex}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      width={width}
      toggleAllState={toggleAllState}
      toggleAllStateFullLenght={reportData.length}
      headerData={headerData}
    />
  )

  return (
    <React.Fragment>
      {reportData && (
        <AppTableDndMobile<
          IBuffetGeneralReportResult,
          keyof IBuffetGeneralReportResult
        >
          toggleAllState={toggleAllState}
          tableName="report-table-visual"
          setHeaderData={setHeaderData}
          setToggleAllState={setToggleAllState}
          data={{
            count: 0,
            results: reportData,
            previous: '',
            next: '',
          }}
          tableWrapperClassName={'buffet-report-table'}
          tableCellClassName={'buffet-report-page-table-cell'}
          rowClassName={'buffet-report-page-table-category'}
          setCurrentSortFn={setCurrentSortValue}
          tableDataSelectors={[
            {
              renderItem: (item, index) => (
                <div
                  className={
                    index
                      ? 'violet-sticky'
                      : 'buffet-report-page-table-category-title'
                  }
                >
                  {t(item?.name)}
                </div>
              ),
            },
            {
              renderItem: (item) => <div></div>,
            },
            {
              renderItem: (item) => <div>{item?.categoryName}</div>,
            },
            {
              renderItem: () => <div className={`text-end`}>{}</div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div />,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.dimensionWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  <ImagePreviewWrapper
                    className={'report-image-preview'}
                    onClick={() => {
                      setSearchParams((sp) => {
                        sp.set('report-image-id', item.id.toString())
                        return sp
                      })
                    }}
                    isReportPageItem={true}
                    image={item.imageOnS3 || item.image}
                    size={ImagePreviewWrapperSizeEnum.MEDIUM}
                  />
                </div>
              ),
            },
          ]}
          subTableRepresent={subTableRepresentFn}
          headerData={headerDataDnd}
        />
      )}
    </React.Fragment>
  )
}
